// LIGHTWEIGHT EMAIL FORMAT CHECK (NOT DELIVERABILITY)
//
// Mirrors the backend's `isValidEmail` (mideo-cloud-functions) so the client's
// pre-submit guard and the cloud function's `invalid-argument` gate agree on
// what "obviously invalid" means: a single `@`, non-empty local part, and a
// dotted domain. Deliberately NOT RFC-5322 exhaustive — a syntactically valid
// address can still bounce, which is the delivery layer's concern (see the
// agent-invite `deliveryStatus` contract), not this function's.
//
// Trims before testing; returns a boolean.
const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;
  return EMAIL_FORMAT.test(email.trim());
};
